import React from 'react';
import { Bonuses } from './components/Bonuses';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { Guarantee } from './components/Guarantee';
import { Hero } from './components/Hero';
import { HowItWorks } from './components/HowItWorks';
import { InsidePreview } from './components/InsidePreview';
import { MetaPixel } from './components/MetaPixel';
import { Modules } from './components/Modules';
import { Pricing } from './components/Offers';
import { Pain } from './components/Pain';
import { RealHomes } from './components/RealHomes';
import { SalesPopup } from './components/SalesPopup';
import { Testimonials } from './components/Testimonials';
import { TopBar } from './components/TopBar';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-white text-slate-700 selection:bg-amber-300 selection:text-blue-950" data-id="element-0" data-mp="28te0v7ntuzkg">
      <MetaPixel data-id="element-1" data-mp="23v2sz2h3ez4v" />
      <TopBar data-id="element-2" data-mp="23ti7e2craqj5" />
      <main data-id="element-3" data-mp="3ik7gihlkcdr6">
        <Hero data-id="element-4" data-mp="3ikh98cxzsz0k" />
        <Pain data-id="element-5" data-mp="3iiweonbohg2p" />
        <HowItWorks data-id="element-6" data-mp="3ijfwm41bw4gq" />
        <RealHomes data-id="element-7" data-mp="3ihv2ugmu8pjx" />
        <Modules data-id="element-8" data-mp="3mlj82snzz920" />
        <InsidePreview data-id="element-9" data-mp="3ml12v6jcxkhy" />
        <Bonuses data-id="element-10" data-mp="3mk8710lxsfel" />
        <Pricing data-id="element-11" data-mp="3mjq1tehaqquj" />
        <Testimonials data-id="element-12" data-mp="3mj6ipufwtwex" />
        <Guarantee data-id="element-13" data-mp="3rcj8i7wbs999" />
        <Faq data-id="element-14" data-mp="3rbzq6q2rjiup" />
        <FinalCta data-id="element-15" data-mp="3rdkgg3i1ofmr" />
      </main>
      <Footer data-id="element-16" data-mp="3recctgjguhe3" />
      <SalesPopup data-id="element-17" data-mp="5yimri0b7dt" />
      <noscript data-id="element-18" data-mp="6hovayao7c0">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1822734912085445&ev=PageView&noscript=1" alt="" data-id="element-19" data-mp="4wxfu7a14id" />
      </noscript>
    </div>;
}